// extracted by mini-css-extract-plugin
export default {"contentcontainer":"ContentContainer_contentcontainer__GxaUB","scrolled":"ContentContainer_scrolled__cXah2"};